import { useContext } from 'react';

import { FormProvider, Controller, UseFormReturn } from 'react-hook-form';

import { ButtonTitleWithLoading } from '@vyce/core/src/components/ButtonTitleWithLoading';
import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
  DialogActions,
  Theme,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { AppTextField } from '@vyce/core/src/components/inputs/AppTextField';
import { DeviceContext } from '@vyce/core/src/contexts/deviceContext';

import { CompanyStep } from '../../onboarding/employer/steps/CompanyStep';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  addPosition: () => void;
  addPositionLoading: boolean;
  methods: UseFormReturn<any>;
}

export const AddPositionDialog: React.FC<Props> = ({
  open,
  setOpen,
  addPosition,
  addPositionLoading,
  methods,
}) => {
  const { isMobile } = useContext(DeviceContext);
  const theme = useTheme<Theme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={fullScreen}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle id="responsive-dialog-title">Add new company</DialogTitle>
      <DialogContent>
        <Box width={isMobile ? '100%' : 500}>
          <FormProvider {...methods}>
            <form>
              <Controller
                control={methods.control}
                rules={{ required: 'Job Title is required' }}
                name="role"
                render={({ field }) => (
                  <AppTextField
                    {...field}
                    error={!!methods.formState.errors.role?.message}
                    id="job-title"
                    label="Job Title"
                    margin="normal"
                    fullWidth
                    helperText={(methods.formState.errors.role?.message as string) || ''}
                  />
                )}
              />

              <CompanyStep />
            </form>
          </FormProvider>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button size="large" onClick={() => setOpen(false)} variant="outlined">
          Cancel
        </Button>

        <Button
          size="large"
          onClick={addPosition}
          variant="contained"
          style={{ width: 100 }}
          color="primary"
          disabled={addPositionLoading}
        >
          <ButtonTitleWithLoading title="Add" loaderVariant="primary" loading={addPositionLoading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
